module.exports = __webpack_public_path__ + "static/media/Resources to support Race Education & Literacy.d4f4ae52.pdf";